import React from 'react';
import { useTranslation } from '../hx/useTranslation';
//import * as FxLog from '../fx/FxLog';
import * as FxDat from '../fx/FxDat';
import CxDlgTable from '../cx/CxDlgTable';

/** Selector independiente para seleccionar un animal de un cliente concreto */

const GxDlgSelectAnimal = (props) => {
  const [{ trans }] = useTranslation();
  const { onSelect, inClient } = props;

  const r_dlg = React.useRef(null);

  const [intermediateValues, setIntermediateValues] = React.useState(null);
  const [dlg, setDlg] = React.useState(false);

  React.useImperativeHandle(props.xref, () => {
    return {
      setOpen, setIntermediateValues
    };
  });

  const setOpen = (boOpen) => {
    if (boOpen) {
      Promise.all([setDlg(true)]).then(() => {
        r_dlg.current.getTable().redisplay();
      });
    } else {
      setDlg(false);
    }
  };

  return (
    <div>

      <CxDlgTable
        xref={r_dlg}
        title={props.title || trans('msg.select_x', trans('field.patient'))}
        hasSearchBox={true}
        open={dlg}
        onClose={() => setDlg(false)}
        onSelect={(row) => {
          if (onSelect) {
            onSelect(row, intermediateValues);
            setDlg(false);
          }
        }}
        url={'animals'}
        filter={`n_animal.inClient='${inClient}'`}
        tooltip={trans('field.patient')}
        refColors={[
          `table_cell_color_gray|${trans('field.inactive')}`,
        ]}
        columns={[
          { id: "inAnimal", Header: "inAnimal", accessor: "inAnimal", show: false },
          {
            id: "txAnimal",
            Header: trans('field.patient'),
            accessor: row => r_dlg.current.getTable().highlightText(row["txAnimal"]),
            width: '60%'
          },
          {
            id: "txSpecies",
            Header: trans('field.species'),
            accessor: "txTypeAnimalSpecies",
            width: '40%'
          },
          {
            id: "A",
            Header: "inactive",
            accessor: row => FxDat.isExpired(row["dtTo"]),
            show: false
          },
        ]}
        height='450px'
      />

    </div>
  );
}

export default GxDlgSelectAnimal;
